import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'store';
import { logout } from 'store/slices/account';
import { resetDashboard } from 'store/slices/dashboard';
import { resetNotification } from 'store/slices/notification';
import { persister } from 'store';
import { resetNewspaperRegisterState } from 'store/slices/newspaperRegister.slice';
import { axiosServicesV3 } from 'utils/services';

export const useLogout = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleLogout = async () => {
        try {
            // Call backend to clear httpOnly cookie
            await axiosServicesV3.post('logout').catch(() => {
                // Continue logout even if backend call fails
                console.log('Backend logout failed, continuing client-side logout');
            });
            
            const logoutChannel = new BroadcastChannel('logout');
            logoutChannel.postMessage('logout');
            dispatch(resetDashboard());
            dispatch(resetNewspaperRegisterState());
            dispatch(resetNotification());
            localStorage.removeItem('imda_expires_in');
            localStorage.removeItem('imda_started');
            localStorage.removeItem('id');
            localStorage.removeItem('imda_sp_expires');
            localStorage.removeItem('uen');
            // irisToken httpOnly cookie cleared by backend
            navigate('/login');
            dispatch(logout());
            persister.purge();
        } catch (error) {
            // Call backend to clear httpOnly cookie even in error case
            await axiosServicesV3.post('logout').catch(() => {
                // Continue logout even if backend call fails
                console.log('Backend logout failed, continuing client-side logout');
            });
            
            dispatch(resetDashboard());
            dispatch(resetNewspaperRegisterState());
            dispatch(resetNotification());
            localStorage.removeItem('imda_expires_in');
            localStorage.removeItem('imda_started');
            localStorage.removeItem('id');
            localStorage.removeItem('imda_sp_expires');
            localStorage.removeItem('uen');
            // irisToken httpOnly cookie cleared by backend
            navigate('/login');
            dispatch(logout());
            persister.purge();
        }
    };
    return handleLogout;
};
export const useLogoutWithoutRedirect = () => {
    const dispatch = useDispatch();
    const handleLogout = async () => {
        try {
            // Call backend to clear httpOnly cookie
            await axiosServicesV3.post('logout').catch(() => {
                // Continue logout even if backend call fails
                console.log('Backend logout failed, continuing client-side logout');
            });
            
            const logoutChannel = new BroadcastChannel('logout');
            logoutChannel.postMessage('logout');
            dispatch(resetDashboard());
            dispatch(resetNewspaperRegisterState());
            dispatch(resetNotification());
            localStorage.removeItem('imda_expires_in');
            localStorage.removeItem('imda_started');
            localStorage.removeItem('id');
            localStorage.removeItem('imda_sp_expires');
            localStorage.removeItem('uen');
            // irisToken httpOnly cookie cleared by backend
            dispatch(logout());
            persister.purge();
        } catch (error) {
            // Call backend to clear httpOnly cookie even in error case
            await axiosServicesV3.post('logout').catch(() => {
                // Continue logout even if backend call fails
                console.log('Backend logout failed, continuing client-side logout');
            });
            
            dispatch(resetDashboard());
            dispatch(resetNewspaperRegisterState());
            dispatch(resetNotification());
            localStorage.removeItem('imda_expires_in');
            localStorage.removeItem('imda_started');
            localStorage.removeItem('id');
            localStorage.removeItem('imda_sp_expires');
            localStorage.removeItem('uen');
            // irisToken httpOnly cookie cleared by backend
            dispatch(logout());
            persister.purge();
        }
    };
    return handleLogout;
};

function getCookie(name: any) {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    if (match) {
        return match[2];
    }
    return null;
}

export const useLogoutAllTabs = () => {
    const dispatch = useDispatch();
    // irisToken is now httpOnly and cannot be read by JavaScript
    // Backend will validate the cookie on each request
    const logoutAllTabs = () => {
        try {
            const logoutChannel = new BroadcastChannel('logout');
            logoutChannel.onmessage = (messageEvent: any) => {
                if (messageEvent.data === 'logout') {
                    dispatch(resetDashboard());
                    dispatch(resetNewspaperRegisterState());
                    dispatch(resetNotification());
                    localStorage.removeItem('imda_expires_in');
                    localStorage.removeItem('imda_started');
                    localStorage.removeItem('id');
                    localStorage.removeItem('imda_sp_expires');
                    localStorage.removeItem('uen');
                    // irisToken is now httpOnly, backend will clear it
                    dispatch(logout());
                    logoutChannel.close();
                    persister.purge();
                }
            };
        } catch (error) {
            dispatch(resetDashboard());
            dispatch(resetNewspaperRegisterState());
            dispatch(resetNotification());
            localStorage.removeItem('imda_expires_in');
            localStorage.removeItem('imda_started');
            localStorage.removeItem('id');
            localStorage.removeItem('imda_sp_expires');
            localStorage.removeItem('uen');
            // irisToken is now httpOnly, backend will clear it
            dispatch(logout());
            persister.purge();
        }
    };

    return logoutAllTabs;
};
